module.exports = __webpack_public_path__ + "media/application/images/tiktok-1-f475e59765b31784b8c16fc1a0690dab.svg";